/** Touch device = phones/tablets: the quality-tier switch (smaller textures,
 *  half-size product images, no SSAO). Guarded so it's safely false under
 *  jsdom/NullEngine tests, which lack matchMedia. */
export function isTouchDevice(): boolean {
  return (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(hover: none) and (pointer: coarse)").matches
  );
}
